// src/pusher/echo.js
import Echo from "laravel-echo";

let echoInstance = null;
// console.log("PUSHER KEY:1", process.env.REACT_APP_PUSHER_KEY);

export function getEcho() {
  // prevent crash in SSR / node
  if (typeof window === "undefined") return null;

  if (echoInstance) return echoInstance;

  //  load pusher-js only in browser
  const Pusher = require("pusher-js");
  window.Pusher = Pusher;

  const key = process.env.REACT_APP_PUSHER_KEY;
  const cluster = process.env.REACT_APP_PUSHER_CLUSTER;

  console.log("PUSHER KEY:1", key);
  console.log("PUSHER KEY:1", cluster);
  if (key == null || key === "" || cluster == null || cluster === "") {
    console.error(
      "Missing REACT_APP_PUSHER_KEY or REACT_PUSHER_APP_CLUSTER in React .env",
    );
    return null;
  }

  echoInstance = new Echo({
    broadcaster: "pusher",
    key,
    cluster,
    forceTLS: true,
  });

  return echoInstance;
}
